export function ERUTemplate(params) {
  return `<table class="esri-widget__table" summary="List of attributes and values">
        <tbody>
            <tr>
                <th class="third">Owner</th>
                <td class="two-third">{Owner}</td>
            </tr>
            <tr>
                <th class="third">ERUs</th>
                <td class="two-third">{ERUs}</td>
            </tr>
            <tr>
                <th class="third">Document</th>
                <td class="two-third">
                    <a target="_blank" href="{Image}" class="ui fluid tiny button">View PDF</a>
                </td>
            </tr>
        </tbody>
    </table>`;
}
